<template>
    <div class="homecontainer">

        <!-- // 回到顶部 -->
        <div class="back-to-top">
            <a class="top" @click="scrollToTop">
                <span>
                    <i class="el-icon-caret-top"></i>
                    <!-- 返回顶部按钮 -->
                </span>
            </a>
        </div>

        <div class="row align-items-center no-gutters">
            <div class="text-center">
                <!-- 顶部轮播图 -->
                <el-carousel height="41.7vw" min-height="312px" style="min-height: 313px; height:41.7vw;" trigger="click">
                    <el-carousel-item v-for="(item, index) in toppicArr" :key="index">
                        <img alt="Image" :src=item.img class="img-fluid">
                    </el-carousel-item>
                </el-carousel>
                <!--top Image -->
                <figure class="w-100">
                    <img alt="Image" src="../assets/img/home/img-about.jpg" class="img-fluid">
                </figure>
            </div>
        </div>
        <div class="row homecontainer no-gutters align-items-center justify-content-center">
            <div class="col-md-12 home-button-container">
                <!--   -->
                <img src="../assets/img/home/img-button-bg.jpg" alt="" class="img-fluid">
                <div class="btn_container ">
                    <button class="btn homebtn btnone" @click="btnoneclick">
                        <h6>园区荣誉</h6>
                        <h6>Exciting Display</h6>
                        <!-- <img src="../assets/img/home/img-button-default.png" alt="btn01" class="img-fluid"> -->
                    </button>
                    <button class="btn homebtn btntwo" @click="btntwoclick">
                        <h6>行业地位</h6>
                        <h6>Craft Inheritance</h6>
                        <!-- <img src="../assets/img/home/img-button-default.png" alt="btn01" class="img-fluid"> -->
                    </button>
                    <button class="btn homebtn btnthird" @click="btnthirdclick">
                        <h6>创新中心</h6>
                        <h6>have great originality</h6>
                        <!-- <img src="../assets/img/home/img-button-default.png" alt="btn01" class="img-fluid"> -->
                    </button>
                </div>
            </div>
        </div>
        <!-- 园区荣誉信息 -->
        <div class="row align-items-center no-gutters" v-if="bShowExcitingInfo">
            <div class="col-lg-12 mt-5 justify-content-center text-center">
                <div class="col-lg-12">
                    <h2 class=" mt-4">园区荣誉</h2>
                </div>
            </div>
            <div class="row w-100 mt-5 mb-5  justify-content-center text-center">
                <div class="col-5 col-sm-5 col-md-4 no-gutters ">
                    <div class="card-body pb-3 no-gutters">
                        <div class="pt-1">
                            <img loading="lazy" src="../assets/img/home/cert-1.jpg" class="img-fluid img-center" alt="Illustration" />
                            <h5 class="h6 lh-130 mt-3">2024年6月荣获京台基层交流基地</h5>
                        </div>
                    </div>
                </div>

                <div class="col-5 col-sm-5 col-md-4 no-gutters ">
                    <div class="card-body pb-3 justify-content-center no-gutters">
                        <div class="pt-1 ">
                            <img loading="lazy" src="../assets/img/home/cert-02.jpg" class="img-fluid img-center" alt="Illustration" />
                            <h5 class="h6 lh-130 mt-3">2022年4月荣获通州区文化创意人才整体提升计划支持单位</h5>
                        </div>
                    </div>
                </div>

                <div class="col-5 col-sm-5  col-md-4 no-gutters ">
                    <div class="card-body pb-3 justify-content-center no-gutters">
                        <div class="pt-1 ">
                            <img loading="lazy" src="../assets/img/home/cert-03.jpg" class="img-fluid img-center" alt="Illustration" />
                            <h5 class="h6 lh-130 mt-3">2024年6月荣获通州区文化产业园区</h5>
                        </div>
                    </div>
                </div>
                <div class="col-5 col-sm-5  col-md-4 no-gutters ">
                    <div class="card-body pb-3 justify-content-center no-gutters">
                        <div class="pt-1 ">
                            <img loading="lazy" src="../assets/img/home/cert-04.jpg" class="img-fluid img-center" alt="Illustration" />
                            <h5 class="h6 lh-130 mt-3">2020年10月荣获2020北京文创大赛通州区分赛场支持单位</h5>
                        </div>
                    </div>
                </div>
                <div class="col-5 col-sm-5  col-md-4 no-gutters ">
                    <div class="card-body pb-3 justify-content-center no-gutters">
                        <div class="pt-1 ">
                            <img loading="lazy" src="../assets/img/home/cert-05.jpg" class="img-fluid img-center" alt="Illustration" />
                            <h5 class="h6 lh-130 mt-3">2023年荣获价格诚信单位评价通则团体标准试点单位</h5>
                        </div>
                    </div>
                </div>
                

            </div>
        </div>
        <!-- 行业地位信息 -->
        <div class="row align-items-center no-gutters" v-if="bShowInheriInfo">
            <div class="text-center">
                <div class="col-lg-12 mt-5 justify-content-center text-center">
                    <div class="col-lg-12">
                        <h2 class=" mt-4">行业地位</h2>
                    </div>
                </div>
                <div class="col-md-12 home-button-container">
                    <img loading="lazy" src="../assets/img/home/img-video.jpg" alt="" class="img-fluid">
                    <div class="videobtn_container ">
                        <button class="btn videobtn" @click="btnvideoclick">
                            <!-- <img src="../assets/img/home/img-button-play.png" alt="btn01" class="img-fluid"> -->
                        </button>
                    </div>

                </div>

                <el-dialog title="" :visible.sync="outerVisible">
                    <div class="videodialog">
                        <video width="100%" height="500px" controls autoplay>
                            <source :src="videoUrl" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>

                    </div>
                </el-dialog>

            </div>
        </div>
        <!-- 创新中心信息 -->
        <div class="row align-items-center no-gutters" v-if="bShowInfo" style="overflow:auto">
            <div class="text-center">
                <div class="col-md-12 home-button-container">
                    <img loading="lazy" src="../assets/img/home/img-video.jpg" alt="" class="img-fluid">
                    <div class="videobtn_container ">
                        <button class="btn videobtn" @click="btnvideoclick">
                            <!-- <img src="../assets/img/home/img-button-play.png" alt="btn01" class="img-fluid"> -->
                        </button>
                    </div>

                </div>

                <el-dialog title="" :visible.sync="outerVisible">
                    <div class="videodialog">
                        <video width="100%" height="500px" controls autoplay>
                            <source :src="videoUrl" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>

                    </div>
                </el-dialog>
            </div>
            <div class="text-center">
                <figure class="w-100 mb-0">
                    <img alt="Image " loading="lazy" :src='require("../assets/img/home/img-01.jpg")' class="img-fluid"/>
                     </figure>
                <figure class="w-100 mb-0">
                    <img alt="Image " loading="lazy" :src='require("../assets/img/home/img-02.jpg")' class="img-fluid"/>
                </figure>
                <figure class="w-100 mb-0">
                    <img alt="Image " loading="lazy" :src='require("../assets/img/home/img-03.jpg")' class="img-fluid"/>
                </figure>
                <figure class="w-100 mb-0 coopenterbg">
                    <img alt="Image " loading="lazy" :src='require("../assets/img/home/img-04.jpg")' class="img-fluid-coopenter"/>
                </figure>
            </div>
        </div>
        <!-- <div>
            <router-view></router-view>
        </div> -->

    </div>
</template>

<script>
// import { url } from 'inspector'

export default {
    name: 'Home',
    data() {
        return {
            bShowExcitingInfo: false,
            bShowInheriInfo: false,
            bShowInfo: true,
            videoUrl: '/video/video-3.mp4',
            outerVisible: false,
            toppicArr:[
                {
                    id:'001234',
                    name:'pic01',
                    img:require("../assets/img/home/img-top.jpg"),
                    url:'',
                },
                {
                    id:'001235',
                    name:'pic02',
                    img:require("../assets/img/msg/messageTop.jpg"),
                    url:'',
                },
                {
                    id:'001236',
                    name:'pic03',
                    img:require("../assets/img/exchange/topbg.jpg"),
                    url:'',
                },
            ]
        }
    },
    methods: {
        btnoneclick() {
            this.bShowExcitingInfo = true
            this.bShowInheriInfo = false
            this.bShowInfo = false
        },
        btntwoclick() {
            this.bShowExcitingInfo = false
            this.bShowInheriInfo = true
            this.bShowInfo = false
        },
        btnthirdclick() {
            this.bShowExcitingInfo = false
            this.bShowInheriInfo = false
            this.bShowInfo = true
        },
        btnvideoclick() {
            // 播放视频
            // this.videoUrl = 'https://11706031.s61i.faiusr.com/58/AD0Ir73KBRA6GAAgv9CClwYo-Jy8hAU.mp4'
            console.log('播放视频');
            this.outerVisible = true
        },
        scrollToTop() {
            // 因为没有滚动条所以此种方法不生效
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            // document.body.scrollTo({
            //     top: 0,
            //     behavior: 'smooth'
            // })
        }
    },
}
</script>

<style lang="less" scoped>

.home-button-container {
    // background-image: url("@/assets/img/home/img-button-bg.jpg");
    display: flex;
    align-content: center;
}

.btn_container {

    padding-left: 14.7%; //282px;
    padding-right: 14.7%;
    width: 100%;
    height: 100%;
    position: absolute;
}

.homebtn {
    height: 100%; //calc(100vw*0.417); //800px
    width: 33.3%; //450  23.4%
    border: 0;
    padding-left: 1px;
    background-image: url('@/assets/img/home/img-button-default.png');
    background-repeat: round
}

.btnone:hover {
    background-image: url("@/assets/img/home/img-button-01.jpg");
    background-repeat: round
}

.btntwo:hover {
    background-image: url("@/assets/img/home/img-button-02.jpg");
}

.btnthird:hover {
    background-image: url("@/assets/img/home/img-button-03.jpg");
}

.videodialog{
    background-color: #333333;
}
.videobtn_container {
    padding-left: 14.7%; //282px;
    padding-right: 14.7%;
    width: 100%;
    height: 100%;
    position: absolute;
}

.videobtn {
    position: relative;
    top: 21%;
    height: 56%; //calc(100vw*0.286); //550px
    width: 40.7%; //550/1350
    border: 0;
    padding-left: 1px;
    background-image: url('@/assets/img/home/img-button-default.png');
    background-repeat: round
}

.el-dialog {
    background-color: #333333 !important;
    width: 70% !important;
}

.el-dialog__header {
    padding-top: 0px !important;

}

.coopenterbg
{
    background-color: #f5f7f9;
}

.img-fluid-coopenter {
    width: 100%;
    max-width: 1200px;
    height: auto;
}

// 返回顶部
.back-to-top {
    position: fixed;
    right: 1rem;
    bottom: 3rem;
    width: 3.6rem;
    z-index: 990;
}

.back-to-top .top {
    margin: 0 auto;
    width: 3rem;
    height: 3rem;
    background: #fff;
    box-shadow: 0 0.04rem 0.16rem 0 rgba(0, 0, 0, 0.18);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2rem;
    text-align: center;
    font-size: 0.8rem;
}

.back-to-top:hover {
    transform: scale(1.1);
}


</style>

